export default __webpack_public_path__ + "static/media/react.f4a209b3.svg";